<script setup lang="ts">
  import { computed } from 'vue'
  import { cva } from 'class-variance-authority'

  interface Props {
    modelValue: boolean
    disabled?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    disabled: false
  })
  const emits = defineEmits(['update:modelValue'])

  const checkboxContainer = computed(() =>
    cva(
      'inline-flex size-6 items-center justify-center rounded-[0.25rem] border border-bt-ui-border bg-white shrink-0',
      {
        variants: {
          type: {
            default: '',
            disabled: 'bt-ui-bg'
          }
        }
      }
    )({
      type: props.disabled ? 'disabled' : 'default'
    })
  )

  const checkboxIcon = computed(() =>
    cva('md-icon md-24 md-icon-fill', {
      variants: {
        type: {
          default: 'text-bt-ui-primary-text',
          disabled: 'text-bt-ui-secondary-text'
        }
      }
    })({
      type: props.disabled ? 'disabled' : 'default'
    })
  )

  const onInput = () => {
    if (props.disabled) return
    emits('update:modelValue', !props.modelValue)
  }
</script>

<template>
  <label class="inline-flex cursor-pointer select-none items-start gap-4">
    <input
      type="checkbox"
      class="hidden"
      :checked="modelValue"
      :disabled="disabled"
      @input="onInput"
    />
    <span
      :class="checkboxContainer"
      tabindex="0"
      @keyup.enter="onInput"
    >
      <i
        v-if="modelValue"
        :class="checkboxIcon"
      >
        check
      </i>
    </span>
    <span class="text-bt-ui-primary-text">
      <slot />
    </span>
  </label>
</template>
